import Spotlight from './Spotlight';

export default Spotlight;
